import script from "./CustomPic.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomPic.vue?vue&type=script&lang=ts&setup=true"

import "./CustomPic.vue?vue&type=style&index=0&id=53d142f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d142f4"]])

export default __exports__